module.exports = __webpack_public_path__ + "img/paul_valery.407cc3da.jpg";